var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accessCompleted"},[_c('img',{attrs:{"src":require("../../../assets/images/accessCompleted.png")}}),_c('div',{staticClass:"tips"},[_vm._v(" "+_vm._s(_vm.$t('channel.accessCompletedTip'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }